import React from 'react';
import { Select, MenuItem } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import styled from 'styled-components';

const Container = styled.div`
  width: 400px;
  padding-top:20px;
  padding-bottom:20px;
`;


export default function ActionDeviationDropdown(props) {
  const [deviationOption, setDeviationOption] = React.useState(props.exisistingDeviationType);

  const handleChange = (event) => {
    setDeviationOption(event.target.value);
    props.onChangeisDeviating(event.target.value);
  };

  return (
    <Container>
      <FormControl component="fieldset" fullWidth>
        <Select
          labelId=""
          id=""
          value={deviationOption}
          label=""
          onChange={handleChange}
        >
          {props.deviationOptions && props.deviationOptions.map((item) => {
            return <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
          })}
        </Select>
      </FormControl>
    </Container>
  );
}